import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { createBlockGameModel } from 'features/block-game';
import { createUnblockGameModel } from 'features/unblock-game';
import { accountTreeModel } from 'entities/account';
import { createGameRegistryModel } from 'entities/game';
import { createGetGamesQuery } from 'shared/api';
import { authorizedGamesRoute } from 'shared/routing';

const getGamesQuery = createGetGamesQuery();

const blockGameModel = createBlockGameModel();

const unblockGameModel = createUnblockGameModel();

const gameRegistryModel = createGameRegistryModel({
	onUpdate: [blockGameModel.mutation.finished.success, unblockGameModel.mutation.finished.success],
});

chain(authorizedGamesRoute.opened, getGamesQuery.start);

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: gameRegistryModel.filters.accountIds.setValue,
});

chain(gameRegistryModel.clearFilters, accountTreeModel.clearSelectedNodes);

export const gamesPageModel = {
	gameRegistryModel,
	blockGameModel,
	unblockGameModel,
	getGamesQuery,
};
